import Vue from 'vue'

Vue.filter('shortDate', function (value) {
  var date = Vue.moment(value)
  return date.format('D MMM')
})

Vue.filter('formattedDate', function (value) {
  var date = Vue.moment(value)
  return date.format('YYYY-MM-DD')
})

Vue.filter('messageDate', function (value) {
  let date = Vue.moment(value)
  let today = Vue.moment()
  let yesterday = Vue.moment().subtract(1, 'days')
  if (date.isSame(today, 'd')) {
    return date.format('HH:mm')
  } else if (date.isSame(yesterday, 'd')) {
    return 'Igår ' + date.format('HH:mm')
  }
  return date.format('D MMM HH:mm')
})
